import { call, put } from "redux-saga/effects";
import { api } from "../../async.saga";
import BackendService from "services/BackendService";

// TODO: use this function for security version uploads and software version uploads
export function* handleFileUpload({
  file,
  params,
  getPresignedApiFn,
  getPreviewApiFn,
  actions,
  transformFile = defaultTransformFile,
  extractMetadata = null, // optional hook for extra steps (e.g., unzip + checksum)
}) {
 
  try {
    // Step 1: Request presigned URL from backend
    const presignedResponse = yield call(api, {
      apiFn: getPresignedApiFn,
      params,
      actions: [
        actions.uploadPending,
        (response) =>
          actions.getPresignedSuccess({ ...response, file, params }),
        actions.uploadFailure,
      ],
    });
    const presignedData = presignedResponse?.data;
    if (!presignedData?.url) return;

    // Step 2: Upload file to S3
    const fileToUpload = transformFile(file);
    yield call(BackendService.uploadFile, presignedData.url, fileToUpload);

    // Step 3 (Optional): Run custom metadata extraction (e.g., unzip + checksums)
    let extraParams = {};
    if (extractMetadata) {
      extraParams = yield call(extractMetadata, fileToUpload);
    }

    // Step 4 (Optional): Send metadata to backend
    if (getPreviewApiFn) {
      const previewParams = {
        versionId: presignedData.versionId,
        ...extraParams,
      };

      yield call(api, {
        apiFn: getPreviewApiFn,
        params: previewParams,
        actions: [
          actions.uploadPending,
          actions.uploadSuccess,
          actions.uploadFailure,
        ],
        requestParams: previewParams,
      });
    } else {
      yield put(actions.uploadSuccess());
    }
  } catch (error) {
    // Trigger failure action with error payload
    yield put(actions.uploadFailure({ message: error.message, error }));
  }
}

function defaultTransformFile(file) {
  return new File([file.originFileObj], {
    type: file.originFileObj.type,
  });
}
